import { render } from "./TheConnect.vue?vue&type=template&id=3728d90c"
import script from "./TheConnect.vue?vue&type=script&lang=js"
export * from "./TheConnect.vue?vue&type=script&lang=js"
script.render = render

export default script